import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModalParts.module.scss';

/* ────────────────────────────────────────────────────────────
 * ModalFooter — the actions row inside <Modal footer={...}>.
 *
 * Right-aligns its children by default with a consistent gap.
 * Pass `align="space-between"` when a secondary control needs
 * to sit on the opposite edge (e.g. a "Delete" link far left,
 * "Save" / "Cancel" right).
 *
 *   <Modal
 *     footer={
 *       <ModalFooter>
 *         <Button variant="ghost" onClick={onClose}>Cancel</Button>
 *         <Button onClick={onSave} loading={saving}>Save</Button>
 *       </ModalFooter>
 *     }
 *     ...
 *   />
 * ──────────────────────────────────────────────────────────── */

const ALIGN_MAP = {
  right: styles.footerAlignRight,
  'space-between': styles.footerAlignBetween,
  center: styles.footerAlignCenter,
};

const ModalFooter = ({ align, children, className }) => (
  <div
    className={[
      styles.footer,
      ALIGN_MAP[align] || ALIGN_MAP.right,
      className || '',
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
);

ModalFooter.propTypes = {
  align: PropTypes.oneOf(['right', 'space-between', 'center']),
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  align: 'right',
  children: null,
  className: '',
};

export default ModalFooter;
